var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('w-button',{attrs:{"tooltip":_vm.$t('myNotification.button.readAll.tooltip'),"tooltip-position":"left","color":"outlined","icon":"check","rounded":true,"size":"small","loading":_vm.loading},on:{"click":function($event){return _vm.markAllAsRead()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }